export const SET_WORKSTATIONWITHSCISSORSTATUSINFO = 'SET_WORKSTATIONWITHSCISSORSTATUSINFO';
